import React from "react";
export function Checkbox({ label, checked, id, onChange }) {
    return (React.createElement("div", { className: "ltg-checkbox" },
        React.createElement("input", { type: "checkbox", onChange: onChange, id: id, className: "sr-only", checked: checked }),
        React.createElement("div", { className: "ltg-checkbox-box", onClick: onChange }),
        label && (React.createElement("label", { htmlFor: id, className: "ltg-checkbox-label" }, label))));
}
